import { track } from '@/lib/analytics/track';
import { TrackingEventName } from '@/models/analytics/eventTypes';
import type { SideNavCreditUsagePopoverContext } from '@heidi/commerce/contracts';
import { ButtonAction, ScreenName } from '@heidi/runtime/analytics-vocabulary';

const TRACK_OPTIONS = { amplitude: false } as const;

export function trackSideNavCreditUsagePopoverViewed({
  usagePercent,
  currentPlan,
  targetPlan,
}: SideNavCreditUsagePopoverContext) {
  track({
    options: TRACK_OPTIONS,
    event_name: TrackingEventName.ModalViewed,
    props: {
      screen_name: ScreenName.SideNavCreditUsagePopover,
      usage_percent: usagePercent,
      target_plan: targetPlan,
      nudge_placement: 'sidebar',
      ...(currentPlan !== undefined && { current_plan: currentPlan }),
    },
  });
}

export function trackSideNavCreditUsagePopoverUpgradeClick({
  usagePercent,
  currentPlan,
  targetPlan,
  label,
}: SideNavCreditUsagePopoverContext & { label: string }) {
  track({
    options: TRACK_OPTIONS,
    event_name: TrackingEventName.ButtonClicked,
    props: {
      screen_name: ScreenName.SideNavCreditUsagePopover,
      action: ButtonAction.SideNavCreditUsagePopoverUpgrade,
      label,
      usage_percent: usagePercent,
      target_plan: targetPlan,
      nudge_placement: 'sidebar',
      ...(currentPlan !== undefined && { current_plan: currentPlan }),
    },
  });
}

export function trackSideNavCreditUsagePopoverExtendTrialClick({
  usagePercent,
  currentPlan,
  targetPlan,
  label,
}: SideNavCreditUsagePopoverContext & { label: string }) {
  track({
    options: TRACK_OPTIONS,
    event_name: TrackingEventName.ButtonClicked,
    props: {
      screen_name: ScreenName.SideNavCreditUsagePopover,
      action: ButtonAction.TrialExtensionSidenavButtonClicked,
      label,
      usage_percent: usagePercent,
      target_plan: targetPlan,
      nudge_placement: 'sidebar',
      ...(currentPlan !== undefined && { current_plan: currentPlan }),
    },
  });
}

export function trackSideNavCreditUsagePopoverCloseClick({
  usagePercent,
  currentPlan,
  targetPlan,
  label,
}: SideNavCreditUsagePopoverContext & { label: string }) {
  track({
    options: TRACK_OPTIONS,
    event_name: TrackingEventName.ButtonClicked,
    props: {
      screen_name: ScreenName.SideNavCreditUsagePopover,
      action: ButtonAction.SideNavCreditUsagePopoverClose,
      label,
      usage_percent: usagePercent,
      target_plan: targetPlan,
      nudge_placement: 'sidebar',
      ...(currentPlan !== undefined && { current_plan: currentPlan }),
    },
  });
}
